import ModuleLoader from "../modules/module.loader";
export default class Lightbox {

	constructor(context, callback) {
    this.context = context;
    this.callback = callback;
    this.items = Array.from(context.querySelectorAll('[data-gallery]'));
    this.toggles = Array.from(context.querySelectorAll('[data-gallery-toggle]'));
	}

  addListeners() {
    this.onMediaClick = this.clickHandler.bind(this);
    this.onToggleClick = this.toggleHandler.bind(this);
    this.items.forEach((item) => item.addEventListener('click', this.onMediaClick));
    this.toggles.forEach((toggle) => toggle.addEventListener('click', this.onToggleClick));
  }

  removeListeners() {
    this.items.forEach((item) => item.removeEventListener('click', this.onMediaClick));
    this.toggles.forEach((toggle) => toggle.removeEventListener('click', this.onToggleClick));
  }

  clickHandler(event) {
    this.items.forEach((item) => item.removeAttribute('data-gallery-active'));
    event.currentTarget.setAttribute('data-gallery-active', true);
    this.mainView();
    this.loadModule();
  }

  toggleHandler() {
    this.items.forEach((item) => item.removeAttribute('data-gallery-active'));
    this.items[0].setAttribute('data-gallery-active', true);
    this.mainView();
    this.loadModule();
  }

  mainView() {
    const main = document.createElement('div');
    main.className = 'lightbox';
    main.setAttribute('data-module', 'lightbox');
    this.main = main;
  }

  loadModule() {
    document.body.appendChild(this.main);
    this.module = new ModuleLoader(this.main, document.body, this.moduleLoaded.bind(this))
  }

  moduleLoaded() {
    window.client.scroller.stop();
  }

  static init(context) {
    Lightbox.item = new Lightbox(context);
    Lightbox.addAllListeners();
  }

  static addAllListeners() {
    Lightbox.item.addListeners()
  }

  static removeAllListeners() {
    Lightbox.item.removeListeners()
  }
}
